// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyASXtuSjcuxud372Ud524O8ta5PkMeXVWg",
    authDomain: "lascumbres-qr.firebaseapp.com",
    databaseURL: "https://lascumbres-qr.firebaseio.com",
    projectId: "lascumbres-qr",
    storageBucket: "lascumbres-qr.appspot.com",
    messagingSenderId: "1043868518712"
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
